import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Quote, Star, ArrowRight } from "lucide-react";
import { testimonials, img, company } from "../mock";
import Seo from "../components/Seo";

const Testimonials = () => {
  const [open, setOpen] = useState(null);

  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.1 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Seo
        title="Testimonials"
        description="Read reviews from Monarch Homes of Brevard homeowners. For over 40 years families across Brevard County have trusted us to build their custom homes."
        keywords="Monarch Homes of Brevard reviews, custom home builder testimonials Melbourne FL"
        path="/testimonials"
      />
      <section className="mh-page-hero" style={{ backgroundImage: `url(${img.living1})` }}>
        <div className="mh-page-hero-inner">
          <div className="mh-crumb"><Link to="/">Home</Link> / Testimonials</div>
          <h1>Testimonials</h1>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">What Our Homeowners Say</div>
            <h2>Trusted By Families Across Brevard</h2>
            <p>For over 40 years, families have trusted Monarch Homes to build the place they call home. Here is what a few of them have to say.</p>
            <div className="mh-divider" />
          </div>

          <div className="mh-grid-3">
            {testimonials.map((t, i) => (
              <div key={i} className="mh-testi-card mh-reveal">
                <Quote size={38} className="mh-testi-quote" />
                <div className="mh-testi-stars">
                  {[0,1,2,3,4].map((s) => (<Star key={s} size={16} fill="currentColor" />))}
                </div>
                <p className="mh-testi-text">{open === i ? t.full : t.short}</p>
                <button className="mh-testi-more" onClick={() => setOpen(open === i ? null : i)}>
                  {open === i ? "Show Less" : "Read Full Review"}
                </button>
                <div className="mh-testi-author">
                  <span className="mh-testi-name">{t.name}</span>
                  <span className="mh-testi-loc">{t.location}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mh-cta-band">
        <div className="mh-container mh-reveal">
          <h2>Ready To Build Your Own Story?</h2>
          <p>Join the many Brevard County families who have made a Monarch home their own.</p>
          <div className="mh-hero-actions">
            <Link to="/contact" className="mh-cta-btn">Get In Touch <ArrowRight size={16} /></Link>
            <a href={company.phoneHref} className="mh-btn-ghost-light">Call {company.phone}</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
